import { atom, selector } from 'recoil';
import { CustomerService } from 'api';
import { getUserDataFromSession } from 'utils/account/getUserDataFromSession';
export const getCustomersRequestId = atom({
  key: 'getCustomersRequestId',
  default: 0
});
export const getCustomers = selector({
  key: 'getCustomers',
  get: async ({
    get
  }) => {
    get(getCustomersRequestId);
    try {
      const userData = getUserDataFromSession();
      let requestOptions = {};
      if (userData) {
        const peopleRegistryRequest = {
          firstName: userData.firstName,
          lastName: userData.lastName,
          socialSecurityNumber: userData.nin,
          birthDate: userData.birthDate
        };
        requestOptions = {
          body: peopleRegistryRequest
        };
      }
      const customers = await CustomerService.getCustomersByAccessToken(requestOptions);
      return customers;
    } catch (error) {
      console.error('Error fetching customers', error);
      return [];
    }
  }
});